"use client";

import { useUserContext } from "@contexts/user-context";
import { clearUser, setUser } from "@utils/client/datadog-rum";
import React, { ReactNode, useEffect } from "react";
import Cookies from "js-cookie";

type MonitoringWrapperProps = {
  children: ReactNode;
};

const MonitoringWrapper: React.FC<MonitoringWrapperProps> = ({ children }) => {
  const { userData, isLoggedIn } = useUserContext();
  useEffect(() => {
    const trackerId = Cookies.get("trackerid");
    const userId = userData?.ekey || (trackerId ? "tr-" + trackerId : undefined);

    if (!userId) {
      clearUser();
      return;
    }

    setUser(userId, {
      is_logged_in: isLoggedIn,
    });
  }, [isLoggedIn, userData?.ekey]);

  return <>{children}</>;
};

export default MonitoringWrapper;
